const consildatedCashFlow = {
  consolidated_cash_flow: `Vista consolidada`,
  filters: "Filtros",
  bank_account: "Cuenta Bancaria",
  reset: "Reiniciar",
  apply: "Aplicar",
  total_credit: "Crédito Total",
  total_debit: "Débito Total",
  cash_flow_overview: "Resumen del Flujo de Caja",
  cash_balance_beginning_month: "Saldo de efectivo al inicio del mes",
  cash_inflow: "Entrada de efectivo",
  cash_outflow: "Salida de efectivo",
  cash_balance_end_month: "Saldo de efectivo al final del mes",
  bankaccount_currency_should_same:
    "Por favor seleccione bancos de la misma moneda",
  select_banks: "Seleccionar Bancos",
};

export default consildatedCashFlow;
